import axios from "axios";

export const API = `${window.location.origin}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
